module.exports = __webpack_public_path__ + "assets/img/miaotiao--blue.993b2aa4.png";